import { BASE_FONT_SIZE } from '@nxtpeople/nxt-styles';
import { checkAddon, checkRoleKey, toRem } from '@nxtpeople/nxt-vue-library';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isoWeek from 'dayjs/plugin/isoWeek';
import { createApp } from 'vue';
import VueVirtualScroller from 'vue-virtual-scroller';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import App from './App.vue';
import { setupDirectives } from './core/helpers/directives.helper';
import keycloak from './core/helpers/keycloak.helper';
import { initSentry } from './core/helpers/sentry.helper';
import i18n from './core/i18n';
import router from './core/router';
import store from './core/store';

const app = createApp(App);

initSentry(app, router);

dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isoWeek);

app.use(keycloak);
app.use(store);
app.use(router);
app.use(i18n);
app.component('DynamicScroller', VueVirtualScroller.DynamicScroller);
app.component('DynamicScrollerItem', VueVirtualScroller.DynamicScrollerItem);
setupDirectives(app);

app.config.globalProperties.$checkRoleKey = checkRoleKey;
app.config.globalProperties.$addon = checkAddon;
app.config.globalProperties.$toRem = (px) => toRem(px, BASE_FONT_SIZE);

app.mount('#app');
